import { collection, doc, getDocs, query, where } from 'firebase/firestore'
import React, { useEffect, useState } from 'react'
import Fade from 'react-reveal/Fade'
import { useNavigate, useParams } from 'react-router'
import Feed from '../../Components/Feed'
import NoContent from '../../Components/NoContent'
import PageContainer from '../../Components/PageContainer'
import Spinner from '../../Components/Spinner'
import { firestore } from '../../firebase'
export default function Search() {
    const { term } = useParams()
    const [results, setResults] = useState(null)
    // const [pollData, setPollData] = useState(new Array())
    useEffect(() => {
        if (!term) {
            return
        }
        const getPolls = async () => {
            const q = query(collection(firestore, "polls"), where("title", "==", term))
            await getDocs(q).then((res) => {
                const newPollData = new Array()
                res.forEach((poll) => newPollData.push({ ...poll.data(), id: poll.id }))
                setResults(newPollData)
            })
        }
        getPolls()
    }, [])
    return (
        <PageContainer>
            <div style={{ padding: "0 30px", marginTop: 40 }} className="pgePadd">
                <div className="flex jcsb aic">
                    <Fade bottom duration={300} delay={500}>
                        <h1>Search results for '{term.length > 15 ? term.substring(0, 15) + "..." : term}'</h1>
                    </Fade>
                </div>
            </div>
            {!results
                ? <>
                    {results === undefined
                        ? <Spinner />
                        : <NoContent />
                    }
                </>
                : <Feed posts={results} />
            }
        </PageContainer>
    )
}
